import { ApolloClient, from, HttpLink, InMemoryCache, split } from "@apollo/client/core";
import { onError } from "@apollo/client/link/error";
import { WebSocketLink } from "@apollo/client/link/ws";
import { getMainDefinition } from "@apollo/client/utilities";
import { TOKEN_KEY } from "./auth";

const { location } = window;
const httpLink = new HttpLink({
  uri: process.env.REACT_APP_GRAPHQL_HTTP_URL,
  credentials: "same-origin",
  headers: {
    authorization: `Bearer ${localStorage.getItem(TOKEN_KEY)}`,
    audience: process.env.REACT_APP_AUDIENCE,
  },
});

const wsLink = new WebSocketLink({
  uri: process.env.REACT_APP_GRAPHQL_WSS,
  options: {
    reconnect: true,
    timeout: 3000,
    connectionParams: {
      authorization: `Bearer ${localStorage.getItem(TOKEN_KEY)}`,
      audience: process.env.REACT_APP_AUDIENCE,
    },
  },
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    const { code } = graphQLErrors[0].extensions;
    if (code === "UNAUTHENTICATED") {
      if (
        document.referrer === "https://papslogistics.com/" &&
        !location.pathname.includes("login") &&
        !location.pathname.includes("logout")
      ) {
        const pathExcludes = /\/reset\/password+|\/account\/confirmation+/g.test(location.pathname);
        if (!pathExcludes) {
          location.replace("/logout");
        }
      }
    }
    graphQLErrors.map(({ message, locations, path }) =>
      console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
    );
  }

  if (networkError) console.log(`[Network error]: ${networkError}`);
});

export const GraphQLClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: split(
    ({ query }) => {
      const definition = getMainDefinition(query);
      return definition.kind === "OperationDefinition" && definition.operation === "subscription";
    },
    wsLink,
    from([errorLink.concat(httpLink)])
  ),
});
